"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lib_1 = require("@brandfree-front/lib");
const StoresUtil_1 = require("../../util/StoresUtil");
let ContactAddressForm = class ContactAddressForm extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "contactAddressStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "inputFieldFilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "inputFieldFocused", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "onAddressAutocompleteSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (address) => {
                this.setState({ addressText: address, roomName: '' });
                this.contactAddressStore.onAddressAutocompleteSelection(address);
            }
        });
        Object.defineProperty(this, "onAddressAutocompleteChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                this.setState({ addressText: value });
                this.onInputFieldFilled('contact-info-address');
                this.contactAddressStore.changeAddressText(value);
            }
        });
        Object.defineProperty(this, "onRoomAutocompleteChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (room) => {
                this.setState({ roomName: room });
                this.onInputFieldFilled('contact-info-room');
                this.contactAddressStore.onRoomAutocompleteChange(room);
                if (room.length === 0 && this.state.addressText) {
                    this.contactAddressStore.onAddressAutocompleteSelection(this.state.addressText);
                }
            }
        });
        Object.defineProperty(this, "onRoomAutocompleteSelection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (room) => {
                this.contactAddressStore.onRoomAutocompleteSelection(room);
            }
        });
        Object.defineProperty(this, "onInputFieldFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field) => {
                if (!this.inputFieldFocused.has(field)) {
                    this.inputFieldFocused.set(field, true);
                }
            }
        });
        Object.defineProperty(this, "onInputFieldFilled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (field) => {
                if (!this.inputFieldFilled.has(field)) {
                    this.inputFieldFilled.set(field, true);
                }
            }
        });
        this.state = {
            addressText: props.addressRepresentation,
            roomName: ''
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.addressRepresentation !== this.state.addressText && nextProps.addressRepresentation) {
            this.setState({
                addressText: nextProps.addressRepresentation
            });
        }
    }
    render() {
        const { translate } = this.translateStore;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'sm-8', 'xl-9'] },
                react_1.default.createElement(lib_1.SuggestionField, { label: translate('contactInfo.postAddress'), items: this.contactAddressStore.addressAutocompleteItems, value: this.state.addressText, onChange: (value) => this.onAddressAutocompleteChange(value), onFocus: () => this.onInputFieldFocus('contact-info-address'), onSelect: (value) => this.onAddressAutocompleteSelection(value.label), helper: this.getAddressHelper(), isInvalid: !this.contactAddressStore.isAddressValid, id: "contact-info-address" })),
            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'sm-4', 'xl-3'] },
                react_1.default.createElement(lib_1.SuggestionField, { label: translate('contactInfo.apartment'), items: this.contactAddressStore.roomAutocompleteItems, value: this.state.roomName, onChange: (value) => this.onRoomAutocompleteChange(value), onFocus: () => this.onInputFieldFocus('contact-info-room'), onSelect: (value) => this.onRoomAutocompleteSelection(value.label), helper: this.getRoomHelper(), isInvalid: !this.contactAddressStore.isRoomValid, id: "contact-info-room", showSuggestionsOnFocus: true }))));
    }
    getAddressHelper() {
        const { translate } = this.translateStore;
        if (!this.contactAddressStore.isAddressValid) {
            return {
                type: 'error',
                text: translate('contactInfo.postAddressInvalid')
            };
        }
        const showPrecisedNotice = this.contactAddressStore.isAddressPrecised;
        const showNotPreciseNotice = this.contactAddressStore.isAddressNotPrecise;
        const precisedNoticeMessage = translate('contactInfo.postAddressPrecised');
        const notPreciseNoticeMessage = translate('contactInfo.postAddressNotPrecise');
        const precisionMessage = showPrecisedNotice ? precisedNoticeMessage : showNotPreciseNotice ? notPreciseNoticeMessage : '';
        return {
            type: 'help',
            text: precisionMessage
        };
    }
    getRoomHelper() {
        const { translate } = this.translateStore;
        if (!this.contactAddressStore.isRoomValid) {
            return {
                type: 'error',
                text: translate('contactInfo.apartmentInvalid')
            };
        }
        return null;
    }
};
ContactAddressForm = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], ContactAddressForm);
exports.default = ContactAddressForm;
